export const isGoogleAuthEnabled = import.meta.env.VITE_IS_GOOGLE_AUTH_ENABLED === "true";
export const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
